import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { CircularProgress } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2.5),
  },
}))

export const Carregando = () => {
  const classes = useStyles()
  return (
    <div className={classes.carregando}>
      <CircularProgress disableShrink />
    </div>
  )
}
